export enum DeleteConfirmationOptions {
  DELETE = 'delete',
  CLOSE = 'close',
  REPORT = 'report',
}
